<template>
  <div class="contentbox" v-if="webConfig">
    <!-- <div class="logo">
        <img src="/static/img/logo21.png" alt="" @click="$router.push('/')">
    </div> -->
    <div class="show" v-if="showInfo">
      <div class="personBox">
        <h1>
          人员基本信息 
        </h1>
        <a href="/" class="back">返回主页</a>
          <table  class="personInfo">
            <tr>
              <td v-if="!(showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')" rowspan="4" style="padding:15px;width:200px">
              <img :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`" alt="">
            </td>
              <td v-if="showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">姓名</td>
              <td>{{ showInfo.name }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">性别</td>
              <td>{{ showInfo.sex }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">证件类型</td>
              <td>{{ showInfo.cardtype }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">身份证号</td>
              <td>{{ showInfo.cardid }}</td>
            </tr>
            <tr>
              <td>出生日期</td>
              <td>{{ showInfo.birthday }}</td>
            </tr>
            <tr>
              <td>学历</td>
              <td>{{ showInfo.education }}</td>
            </tr>
            <tr>
              <td>工作单位</td>
              <td>{{ showInfo.danwei }}</td>
            </tr>
          </table>
          <div class="hengx"></div>
      </div>
      <div  class="certBox">
        <h1>
          证书基本信息
        </h1>
        <table  class="personInfo">
          <tr>
            <td>证书类别</td>
            <td>{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td>证书编号</td>
            <td >{{ showInfo.code }}</td>
          </tr>
          <tr>
            <td>申报专业</td>
            <td >{{ showInfo.certname }}</td>
          </tr>
          <tr v-if="!(showInfo.certtypename=='专业技术人才职业技能培训证书'||showInfo.certtypename=='职业技能培训合格证书'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')">
            <td>专业方向</td>
            <td >{{ showInfo.majorfield }}</td>
          </tr>
          <tr>
            <td>考试成绩</td>
            <td>{{ showInfo.certscore }}</td>
          </tr>
          <tr>
            <td>申报级别</td>
            <td>{{ showInfo.certlevel }}</td>
          </tr>
          <tr>
            <td>发证日期</td>
            <td>{{ showInfo.certdate }}</td>
          </tr>
          <!-- <tr>
            <td>有效日期</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td>
          </tr> -->
          <tr>
            <td>证书颁发机构</td>
            <td >{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td>发证机构网址</td>
            <td>{{ showInfo.regurl }}</td>
          </tr>
        </table>
        <div class="hengx"></div>
      </div>
      <div  class="certBox">
        <h1>
          继续教育记录
        </h1>
        <table class="personInfo">
          <div v-for="item in  pagenum" :key="item">
            <tr class="title">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].title:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].title:''}}</td>
            </tr>
            <tr class="date">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].date:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].date:''}}</td>
              
            </tr>
          </div>
        </table>
        <div class="hengx"></div>
      </div>  
    </div>
  </div>

</template>

<script>
/**
 * 个人证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
import { getFindAll } from '../../request/get'
export default {
  name: "ShowGr",
  data() {
    return {
      IP_TEST,
      arrSprtQys:[],
      pagenum:1,
      webConfig:null
    }
  },
  computed: {
  },
  created(){
    this.getFindAll();
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.pagenum = Math.ceil( this.arrSprtQys.length/2);
      if(this.pagenum===0)this.pagenum=1;
    }
  },
  props: {
    showInfo: Object
  },
    mounted() {
    console.log(this.$el);
	// this.creatQrCode(this.showInfo.cardid,this.showInfo.name,this.showInfo.bzcode,this.showInfo.certname);
  },
  methods: {
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.webConfig = result;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
   formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  },
  }
};
</script>
<style scoped>
.contentbox{
  background-image: url(/static/img/grphone.png);
  /* height: 1300px; */
}
.contentbox .header{
  height: 45px;
    background: #094DA6;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding: 30px 0 30px 0;
}
.personBox{
  background: rgba(255,255,255,0.95);
  border-radius: 8px;
  padding-bottom: 16px;
}
.certBox{
  margin-top:18px;
  background: rgba(255,255,255,0.95);
  border-radius: 8px;
  padding-bottom: 16px;
}
.hengx{
  margin-top:18px;
  border: 3px solid #0157C6;
  
}
.logo{
    text-align: center;
    position: relative;
    top: 12px;
}
.logo img{
  width: 344px;
}
.contentbox .show{
  width: 344px;
  margin: auto;
  margin-top: 50px;
  padding-bottom: 40px;
  /* height: 965px; */
}
.show h1{
  background-image: url(/static/img/infotitile.png);
  background-repeat:no-repeat;
  color: #fff;
font-size: 12px;
  width: 136px;
  height:28px;
  line-height: 28px;
  position: relative;
    top: 8px;
}
.back{
  color: #000;
    float: right;
    position: relative;
    top: -10px;
    right: 15px;
    letter-spacing: 2px;
    border-bottom: solid 1px;
    line-height: 16px;
}
.personInfo{
  width:312px;
  margin: auto;
  margin-top: 16px;
  font-size: 24px;
  border-collapse:collapse;
  border-spacing:0;
  border-left:1px solid #579BF1;;
  border-top:1px solid #579BF1;;
}
.personInfo td{
  border-right:1px solid #579BF1;
  border-bottom:1px solid #579BF1;
  /* padding:5px 15px; */
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
}
.personInfo tr td:nth-child(2n-1){
  width: 97px;
}
.personInfo tr td:nth-child(2n){
  width: 290px;
}
.theader{
  text-align: center;
  font-weight: bold;
  color: #0157C6;
  line-height: 28px;
}
.headerbox a{
  float: right;
    font-size: 18px;
    color: #fff;
    margin-top: 12px;
    margin-right: 10px;
    border-bottom: 1px solid;
    line-height: 25px;
    letter-spacing: 3px;
}
.personInfo .title td:nth-child(2n-1){
  width: 25%;
    height: 60px;
    text-align: center;
    padding: 0;
    line-height: 60px;
    color: red;
}
.personInfo .title td:nth-child(2n){
  width: 25%;
    height: 60px;
    text-align: center;
    padding: 0;
    line-height: 60px;
    color: red;
}

.personInfo .date td:nth-child(2n-1){
    height: 30px;
    text-align: center;
    padding: 0;
    line-height: 30px;
    color: red;
}
.personInfo .date td:nth-child(2n){
    text-align: center;
    padding: 0;
    height: 30px;
    line-height: 30px;
    color: red;
}
</style>